import React from "react";
import { MyInfoImgWrapper } from "./styled";
import cloudfront from "helpers/cloudfront";

const MyInfoImg = ({ image }) => {
  return <MyInfoImgWrapper image={cloudfront({ href: image, size: "large" })} />;
};

export default MyInfoImg;
